import React from 'react';
import styles from './style.module.css';

import quotesOpen from '../../../assets/img/icon/quotes-open.svg';
import quotesClose from '../../../assets/img/icon/quotes-close.svg';

export default function QuotesSection() {
  return (
    <div className={styles.root}>
      <div className={styles.quotesText}>
        <div className={styles.quotesOpen}>
          <img src={quotesOpen} alt=" " />
        </div>
        <p>
          Dengan berkurangnya air bersih sementara penggunaan terus meningkat
          maka pengelolaan Sumber Daya Air dan resikonya merupakan poin penting
          bagi usaha bisnis terutama di sektor migas.
        </p>
        <div className={styles.quotesClose}>
          <img src={quotesClose} alt=" " />
        </div>
        <span className={styles.quotesSource}>
          Pengelolaan Sumber Daya Air Pertamina
        </span>
      </div>
    </div>
  );
}
